module.exports = __webpack_public_path__ + "_/assets/images/icons/icon_calendar-6640d07bd7747c58890d8e073c1603d1.svg";